import { render } from "./NewObjectRelation.vue?vue&type=template&id=4e15f020"
import script from "./NewObjectRelation.vue?vue&type=script&lang=js"
export * from "./NewObjectRelation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__